import { call, all } from 'redux-saga/effects';
import { onAddBankAccount } from './addAccounts';
import { onGetBankAccount } from './getAccounts';

export default function* intPaymentSaga() {
  yield all([
    call(onAddBankAccount),
    call(onGetBankAccount)
  ]);
}